export default __webpack_public_path__ + "static/media/time-tracker-react-sm.d8a0927e.jpg";